import { COURSE_TYPES } from 'constants/common';

export const convertDataToApi = (data: any) => ({
  type: COURSE_TYPES.ARCADE,
  platform: data.platform.value,
  schoolId: data.school.value,
});
